// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__JQYV-","row":"styles_row__1RYFo"};